const isValid = (value) => value !== 0 && Number.isFinite(value);
const findInvalidPrice = (data, lastCachedItem) => data.find((item, index) => {
    if (!Number.isFinite(item.close) || !Number.isFinite(item.open))
        return true;
    if (lastCachedItem && isValid(lastCachedItem.close) && index === 0) {
        return !isValid(item.close);
    }
    if (index > 0) {
        const prevItem = data[index - 1];
        if (!isValid(item.close) && isValid(prevItem.close))
            return true;
        if (!isValid(item.open) && isValid(prevItem.open))
            return true;
    }
});
export default findInvalidPrice;
